module.exports = __webpack_public_path__ + "img/pen-size-5.b0769c10.svg";